module.exports = "<a href=\"kits-e-programas/popup-item/{{ porcao | linkfy }}-{{ porcao_id }}\" class=\"fancy fancybox.ajax\">\n\t{{ produto }} - {{ porcao }}\n</a>"


//////////////////
// WEBPACK FOOTER
// ./views/kits/interna/item.twig
// module id = 39
// module chunks = 0